// Chakra imports
import { Avatar, Box, Text, useColorModeValue } from "@chakra-ui/react";
import Card from "components/card/Card.js";
import React from "react";

export default function Banner(props) {
  const { banner, avatar, herotag, address } = props;
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const borderColor = useColorModeValue(
    "white !important",
    "#353535 !important"
  );

  return (
    <Card mb={{ base: "0px", lg: "20px" }} align='center'>
      <Box
        bg={`url(${banner})`}
        bgSize='cover'
        bgPosition={'center'}
        borderRadius='16px'
        h='400px'
        w='100%'
      />
      <Avatar
        mx='auto'
        src={avatar}
        h='87px'
        w='87px'
        mt='-43px'
        border='4px solid'
        borderColor={borderColor}
      />
      {!!herotag && (
      <Text color={textColorPrimary} fontWeight='bold' fontSize='xl' mt='10px'>
          @{herotag}
      </Text>
      )}
      <Text color={textColorSecondary} fontSize='sm'>
        {address}
      </Text>
    </Card>
  );
}
